module.exports = __webpack_public_path__ + "img/sfq1.d51c719a.png";